import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, Grid, IconButton, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import { isIOS, Option } from 'components/Option';
import { sortingTypeLabel } from 'helpers/sortingTypeLabel';
import { styles } from './styles';

const useStyles = makeStyles(styles);

const sortOf = ({ sortBy, sortOrder }) => ({ sortBy, sortOrder });

const FiltersDrawer = ({ open, value, onApply, onClose }) => {
  const classes = useStyles();
  const [draft, setDraft] = useState(sortOf(value));

  useEffect(() => setDraft(sortOf(value)), [value, open]);

  return (
    <Drawer anchor="right" open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid item xs="auto">
          <Typography variant="h3">Filters</Typography>
        </Grid>
        <Grid item xs="auto">
          <IconButton onClick={onClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      <div className={classes.form}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <label htmlFor="sortBy" className={classes.label}>
              <Typography variant="body1" color="textSecondary">
                Sort by:
              </Typography>
              <TextField
                select
                id="sortBy"
                name="sortBy"
                value={draft.sortBy}
                onChange={(event) => setDraft({ ...draft, sortBy: event.target.value })}
                variant="outlined"
                inputProps={{ 'aria-label': 'Sort by' }}
                SelectProps={{ native: isIOS }}
                fullWidth
              >
                <Option value=""></Option>
                <Option value="username">Username</Option>
                <Option value="employeeNum">Employee #</Option>
              </TextField>
            </label>
          </Grid>

          <Grid item xs={12} lg={6}>
            <label htmlFor="sortOrder" className={classes.label}>
              <Typography variant="body1" color="textSecondary">
                Sort from:
              </Typography>
              <TextField
                select
                id="sortOrder"
                name="sortOrder"
                value={draft.sortOrder}
                onChange={(event) => setDraft({ ...draft, sortOrder: event.target.value })}
                variant="outlined"
                inputProps={{ 'aria-label': 'Sort from' }}
                SelectProps={{ native: isIOS }}
                fullWidth
              >
                {sortingTypeLabel(draft.sortBy).map(({ label, value: order }) => (
                  <Option key={order} value={order}>
                    {label}
                  </Option>
                ))}
              </TextField>
            </label>
          </Grid>

          <Grid item xs={12}>
            <Button color="primary" onClick={() => setDraft({ sortBy: '', sortOrder: 'asc' })}>
              Reset all filters
            </Button>
          </Grid>
        </Grid>

        <div className={classes.buttonHolder}>
          <Button color="secondary" className={classes.button} onClick={onClose}>
            Cancel
          </Button>

          <div className={classes.verticalDivider} />

          <Button color="primary" className={classes.button} onClick={() => onApply(draft)}>
            Apply
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

FiltersDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  value: PropTypes.shape({
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
  }).isRequired,
  onApply: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FiltersDrawer;
